<template>
	<v-container>
		<v-row>
			<v-col cols="12" md="6" class="">
				<v-card outlined>
					<v-card-title>
						<span>Города обслуживания</span>
						<v-spacer />
						<create-city-modal @created="fetchCities()" />
					</v-card-title>
					<v-card-text>
						<v-data-table
							:headers="headers"
							:items="cities.data"
							:server-items-length="cities.meta.total"
							:loading="loading"
							loading-text="Загрузка..."
							@update:page="fetchCities($event)"
							@update:items-per-page="fetchCities(1, $event)"
						>
							<template #item.rate_per_hour="{ item: city }">
								<v-edit-dialog
									@open="dialogs.edit.rate = city.rate_per_hour"
									@save="updateCityRatePerHour(city, dialogs.edit.rate)"
								>
									{{ city.rate_per_hour }}₽
									<template #input>
										<v-text-field
											v-model="dialogs.edit.rate"
											label="Ставка в час"
											single-line
										/>
									</template>
								</v-edit-dialog>
							</template>
							<template #item.actions="{ item: city }">
								<v-tooltip top>
									<template #activator="{ on }">
										<v-btn
											icon
											small
											@click="deleteCity(city)"
											v-on="on"
										>
											<v-icon color="red">mdi-delete</v-icon>
										</v-btn>
									</template>
									<span>Удалить</span>
								</v-tooltip>
							</template>
						</v-data-table>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import CreateCityModal from '@/components/cities/create-modal';

const HEADERS = [
	{ text: 'Город', value: 'name' },
	{ text: 'Ставка (за нормо-час)', value: 'rate_per_hour', align: 'end' },
	{ text: 'Действия', value: 'actions', align: 'end' },
];

export default {
	name: 'CitiesIndex',
	components: { CreateCityModal },
	data: () => ({
		loading: false,
		cities: {
			data: [],
			meta: {
				total: 0,
				per_page: 50,
			},
		},
		dialogs: {
			edit: {
				rate: null,
			},
		},
	}),
	computed: {
		headers() {
			return HEADERS;
		},
	},
	mounted() {
		this.fetchCities();
	},
	methods: {
		async fetchCities(page = 1, limit = null) {
			if (this.loading) {
				return;
			}
			this.loading = true;
			limit = limit ? limit : this.cities.meta.per_page;
			try {
				const response = await this.$http.get('/api/v2/service/cities', {
					params: {
						page,
						limit,
					},
				});

				this.cities = response.data;
			} catch (e) {
				this.$notify.error(e.message);
			} finally {
				this.loading = false;
			}
		},
		async deleteCity(city) {
			try {
				await this.$http.delete(`/api/v2/service/cities/${city.id}`);
				this.$notify('Город удален');
				await this.fetchCities();
			} catch (e) {
				this.$notify.error(e.message);
			}
		},
		async updateCityRatePerHour(city, rate_per_hour) {
			await this.updateCity(city, {
				rate_per_hour,
			});
		},
		async updateCity(city, data) {
			if (this.loading) return;
			this.loading = true;
			try {
				const response = await this.$http.patch(`/api/v2/service/cities/${city.id}`, data);
				this.$notify('Город изменен');
				city = response.data.data;
				this.cities.data = this.cities.data.map(c => c.id === city.id ? city : c);
			} catch (e) {
				this.$notify.error('Ошибка');
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>

<style scoped>

</style>
